import { render } from "./CalendarButton.vue?vue&type=template&id=5f23edc2"
import script from "./CalendarButton.vue?vue&type=script&lang=js"
export * from "./CalendarButton.vue?vue&type=script&lang=js"

import "./CalendarButton.vue?vue&type=style&index=0&id=5f23edc2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__